import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, PublicAccountReducer, PublicAccountState } from './public-account-reducer';


const PublicAccountContext = createContext<PublicAccountState | undefined>(undefined);
const PublicAccountContextDispatchContext = createContext({} as any);

const PublicAccountProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(PublicAccountReducer, {} as PublicAccountState);

    return (
        <PublicAccountContext.Provider value={state}>
            <PublicAccountContextDispatchContext.Provider value={dispatch}>
                {children}
            </PublicAccountContextDispatchContext.Provider>
        </PublicAccountContext.Provider>
    );
}

const usePublicAccountState = () => {
    const context = useContext(PublicAccountContext);
    if (context === undefined) {
        throw new Error('useHomeState must be used within a HomeProvider');
    }
    return context;
}

const usePublicAccountDispatch = () => {
    const context = useContext(PublicAccountContextDispatchContext);
    if (context === undefined) {
        throw new Error('useHomeDispatch must be used within a HomeProvider');
    }
    return context;
}

export { PublicAccountProvider, usePublicAccountState, usePublicAccountDispatch, ACTION_TYPES };

